export enum EventFeedEnum {
	ForYou = 'for-you',
	EditorPick = 'editor-pick',
	Trending = 'trending',
	Following = 'following',
	Interest = 'interest',
}